import React, { useMemo, isValidElement, useCallback, useRef } from "react";
import { Box, Stack, Button } from "@bookingcom/bui-react";
import { ArrowNavLargeLeftIcon, HeartOutlineIcon, ShareIcon } from "@bookingcom/bui-assets-react/streamline";
export function FlightDetailsHeaderMobileUI(props) {
    const { backgroundImageUrl, attributes, backButton, favoriteButton, shareButton } = props;
    const imgRef = useRef(null);
    const boxAttributes = useMemo(() => ({
        ...attributes,
        style: {
            ...attributes?.style,
            paddingBottom: 0,
            position: "relative",
            backgroundColor: "var(--bui_color_brand_primary_background)"
        }
    }), [attributes]);
    const imgStyle = useMemo(() => ({
        position: "absolute",
        width: "100%",
        height: "100%",
        top: 0,
        left: 0,
        opacity: 0,
        objectFit: "cover",
        objectPosition: "center",
        transition: "all 0.3s ease-in-out"
    }), []);
    const handleOnLoad = useCallback(() => {
        imgRef.current?.style.setProperty("opacity", "1");
    }, []);
    const handleOnError = useCallback(() => {
        imgRef.current?.style.setProperty("opacity", "0");
        imgRef.current?.style.setProperty("display", "none");
    }, []);
    return (React.createElement(Box, { attributes: boxAttributes },
        React.createElement("img", { alt: "", ref: imgRef, "aria-hidden": "true", onLoad: handleOnLoad, onError: handleOnError, src: backgroundImageUrl, style: imgStyle }),
        React.createElement(Stack, { direction: "row" },
            React.createElement(Stack.Item, { grow: true }, isValidElement(backButton) ? (backButton) : backButton ? (React.createElement(Button, { variant: "elevated", size: "large", icon: ArrowNavLargeLeftIcon, ...backButton })) : undefined),
            isValidElement(favoriteButton) ? (favoriteButton) : favoriteButton ? (React.createElement(Button, { variant: "elevated", size: "large", icon: HeartOutlineIcon, ...favoriteButton })) : undefined,
            isValidElement(shareButton) ? (shareButton) : shareButton ? (React.createElement(Button, { variant: "elevated", size: "large", icon: ShareIcon, ...shareButton })) : undefined),
        React.createElement(Box, { borderRadius: 300, backgroundColor: "elevation_one", padding: 2, mixin: { marginInlineStart: -4, marginInlineEnd: -4, marginBlockStart: 12 }, attributes: {
                style: {
                    zIndex: 1,
                    position: "relative",
                    borderEndEndRadius: 0,
                    borderEndStartRadius: 0
                }
            } })));
}
